import * as React from 'react';
import { useNavigate } from "react-router-dom";
import { Component, createRef } from 'react';

import { Button, Card, CardBody, CardGroup, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink  } from 'reactstrap';
import { IStackTokens, Stack } from '@fluentui/react/lib/Stack';
import { Dropdown, IDropdown, DropdownMenuItemType, IDropdownStyles, IDropdownOption,} from '@fluentui/react/lib/Dropdown';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { ChoiceGroup, IChoiceGroupOption } from '@fluentui/react/lib/ChoiceGroup';
import { TextField, MaskedTextField } from '@fluentui/react/lib/TextField';
import { Toggle } from '@fluentui/react/lib/Toggle';
const dropdownStyles = {
	dropdown: { width: 300 },
  };
  const stackTokens = { childrenGap: 20 };
  const options_diseases = [
	{ key: '', text: 'Select an option'},
	{ key: '%_cute_Myeloid_Leukemia%', text: 'Acute Myeloid Leukemia'},
	{ key: '%_ggressive_Mastocytosis%', text: 'Aggressive Mastocytosis'},
	{ key: '%_topic_Dermatitis%', text: 'Atopic Dermatitis'},
	{ key: '%_ppendiceal_Cancer%', text: 'Appendiceal Cancer'},
	{ key: '%_utism_Spectrum_Disorder%', text: 'Autism Spectrum Disorder'},
	{ key: '%_ladder_Cancer%', text: 'Bladder Cancer'},
	{ key: '%_reast_Cancer%', text: 'Breast Cancer'},
	{ key: '%_reast_lesions%', text: 'Breast Lesions'},
	{ key: '%_olon_Carcinoma%', text: 'Colon Carcinoma'},
	{ key: '%_olon_Cancer%', text: 'Colon cancer'},
	{ key: '%_olorectal_Cancer%', text: 'Colorectal Cancer'},
	{ key: '%_oronary_Artery_Disease%', text: 'Coronary Artery Disease'},
	{ key: '%_rohn_Disease%', text: 'Crohn Disease'},
	{ key: '%_ermatomyositis%', text: 'Dermatomyositis'},
	{ key: '%_iabetic_Kidney%', text: 'Diabetic Kidney'},
	{ key: '%_rdheim_Chester_Histiocytosis%', text: 'Erdheim Chester Histiocytosis'},
	{ key: '%_astric_Cancer%', text: 'Gastric Cancer'},
	{ key: '%_ingivitis%', text: 'Gingivitis'},
	{ key: '%_lioblastoma%', text: 'Glioblastoma'},
	{ key: '%_lioma%', text: 'Glioma'},
	{ key: '%_ealthy%', text: 'Healthy'},
	{ key: '%_ealthy_First_Trimester_Pregnant%', text: 'Healthy First Trimester Pregnant'},
	{ key: '%_ealthy_Pregnant_Women%', text: 'Healthy Pregnant Women'},
	{ key: '%_ead_and_Neck_Cancer%', text: 'Head and Neck Cancer'},
	{ key: '%_epatitis_B%', text: 'Hepatitis B'},
	{ key: '%_epatoxicity%', text: 'Hepatoxicity'},
	{ key: '%_epatocellular_Carcinoma%', text: 'Hepatocellular Carcinoma'},
	{ key: '%_uman_Immunodeficiency_Virus%', text: 'Human Immunodeficiency Virus'},
	{ key: '%_idney_Allograft_Injury%', text: 'Kidney Allograft Injury'},
	{ key: '%_ung_Adenocarcinoma%', text: 'Lung Adenocarcinoma'},
	{ key: '%_elanoma%', text: 'Melanoma'},
	{ key: '%_etastatic_Breast_Cancer%', text: 'Metastatic Breast Cancer'},
	{ key: '%_etastatic_Castration_Resistant_Prostate_Cancer%', text: 'Metastatic Castration Resistant Prostate Cancer'},
	{ key: '%_etastatic_Colorectal_Cancer%', text: 'Metastatic Colorectal Cancer'},
	{ key: '%_etastatic_Melanoma%', text: 'Metastatic Melanoma'},
	{ key: '%_etastatic_Urothelial_Carci%', text: 'Metastatic Urothelial Carcinoma'},
	{ key: '%_ultiple_Myeloma%', text: 'Multiple Myeloma'},
	{ key: '%_ultiple_Sclerosis%', text: 'Multiple Sclerosis'},
	{ key: '%_euroblastoma%', text: 'Neuroblastoma'},
	{ key: '%_on-small-cell_Lung_Cancer%', text: 'Non-small-cell Lung Cancer'},
	{ key: '%_on-Squamous_Non-small-cell_Lung_Cancer%', text: 'Non-Squamous Non-small-cell Lung Cancer'},
	{ key: '%_ormotensive_Pregnancies%', text: 'Normotensive Pregnancies'},
	{ key: '%_steosarcoma%', text: 'Osteosarcoma'},
	{ key: '%_varian_Cancer%', text: 'Ovarian Cancer'},
	{ key: '%_ancreatic_Cancer%', text: 'Pancreatic Cancer'},
	{ key: '%_arkinson_Disease%', text: 'Parkinson Disease'},
	{ key: '%_ancreatic_Ductal_Adenocarcinoma%', text: 'Pancreatic Ductal Adenocarcinoma'},
	{ key: '%_apillary_Thyroid_Cancer%', text: 'Papillary Thyroid Cancer'},
	{ key: '%_araganglioma%', text: 'Paraganglioma'},
	{ key: '%_heochromocytoma%', text: 'Pheochromocytoma'},
	{ key: '%_latelet_Transfusion_Adverse_Reaction%', text: 'Platelet Transfusion Adverse Reaction'},
	{ key: '%_reeclampsia%', text: 'Preeclampsia'},
	{ key: '%_rostate_Cancer%', text: 'Prostate Cancer'},
	{ key: '%_ulmonary_Adenocarcinoma%', text: 'Pulmonary Adenocarcinoma'},
	{ key: '%_enal_Cell_Carcinoma%', text: 'Renal Cell Carcinoma'},
	{ key: '%_etroperitoneal_liposarcoma%', text: 'Retroperitoneal liposarcoma'},
	{ key: '%_hesus_D_Negative_Pregnant_Women%', text: 'Rhesus D Negative Pregnant Women'},
	{ key: '%_epsis%', text: 'Sepsis'},
	{ key: '%_erous_Carcinoma%', text: 'Serous Carcinoma'},
	{ key: '%_quamous_Cell_Carcinoma%', text: 'Squamous Cell Carcinoma'},
	{ key: '%_ystemic_Lupus_Erythematosus%', text: 'Systemic Lupus Erythematosus'},
	{ key: '%_uberculous_Meningitis%', text: 'Tuberculous Meningitis'},
	{ key: '%_uberculosis%', text: 'Tuberculosis'},
	{ key: '%_rothelial_Bladder_Carcinoma%', text: 'Urothelial Bladder Carcinoma'},
];

const options_source = [
	{ key: '', text: 'Select an option'},
	{ key: '%_uman-ascites%', text: 'Human-ascites'},
	{ key: '%_uman-bronchoalveolar_Lavage_Fluid%', text: 'Human-bronchoalveolar Lavage Fluid'},
	{ key: '%_uman-cerebrospinal_Fluid%', text: 'Human-cerebrospinal Fluid'},
	{ key: '%_uman-endometrial_Fluid%', text: 'Human-endometrial fluid'},
	{ key: '%_uman-gastric_juice%', text: 'Human-gastric juice'},
	{ key: '%_uman-lymphatic_Drainage%', text: 'Human-lymphatic Drainage'},
	{ key: '%_uman-peripheral_Blood%', text: 'Human-peripheral Blood'},
	{ key: '%_uman-placentae%', text: 'Human-placentae'},
	{ key: '%_uman-plasma%', text: 'Human-plasma'},
	{ key: '%_uman-pleural_Effusion%', text: 'Human-pleural Effusion'},
	{ key: '%_uman-saliva%', text: 'Human-saliva'},
	{ key: '%_uman-seminal_Plasma%', text: 'Human-seminal Plasma'},
	{ key: '%_uman-serum%', text: 'Human-serum'},
	{ key: '%_uman-Sweat%', text: 'Human-sweat'},
	{ key: '%_uman-tears%', text: 'Human-tears'},
	{ key: '%_uman-urine%', text: 'Human-urine'},
	
];
const option_yearofpublications = [
	{ key: '', text: 'Select an option'},
	{ key: '2009', text: '2009'},
	{ key: '2013', text: '2013'},
	{ key: '2014', text: '2014'},
	{ key: '2015', text: '2015'},
	{ key: '2016', text: '2016'},
	{ key: '2017', text: '2017'},
	{ key: '2018', text: '2018'},
	{ key: '2019', text: '2019'},
	{ key: '2020', text: '2020'},
	{ key: '2021', text: '2021'},
	{ key: '2022', text: '2022'},
	{ key: '2023', text: '2023'},
	{ key: '2024', text: '2024'},
];

const options_evisolationmethods = [
	{ key: '', text: 'Select an option'},
	{ key: '%_coustofluidic_Separation%', text: 'Acoustofluidic Separation'},
	{ key: '%_entrifugation%', text: 'Centrifugation'},
	{ key: '%_xo-Flow%', text: 'Exo-Flow'},
	{ key: '%_xoEasy%', text: 'ExoEasy'},
	{ key: '%_xoLution%', text: 'ExoLution'},
	{ key: '%_xoQuick%', text: 'ExoQuick'},
	{ key: '%_xoRNeasy%', text: 'ExoRNeasy'},
	{ key: '%_luorescence_activated_vesicles_sorting%', text: 'Fluorescence‐activated vesicles sorting'},
	{ key: '%_eparin/polymer-coated_microspheres%', text: 'Heparin/polymer-coated microspheres'},
	{ key: '%_nvitrogen%', text: 'Invitrogen'},
	{ key: '%_mmuno-affinity_capture%', text: 'Immuno-affinity capture'},
	{ key: '%ME__Kit%', text: 'ME™ Kit'},
	{ key: '%_icrofluidic_Isolation_of_Tumor-derived_Extracellular_Vesicles%', text: 'Microfluidic Isolation of Tumor-derived Extracellular Vesicles'},
	{ key: '%_anostructured_silica_platform%', text: 'Nanostructured silica platform'},
	{ key: '%_iRCURY%', text: 'miRCURY'},
	{ key: '%Not_available%', text: 'Not available'},
	{ key: '%_ptitPrep%', text: 'OptitPrep'},
	{ key: '%_olyethylene_glycol%', text: 'Polyethylene glycol'},
	{ key: '%PureExo%', text: 'PureExo'},
	{ key: '%_apid_magnetic_beads_isolation%', text: 'Rapid magnetic beads isolation'},
	{ key: '%_ize_Exclusion_Chromatography%', text: 'Size exclusion chromatography'},
	{ key: '%_ucrose_density_gradient%', text: 'Sucrose density gradient'},
	{ key: '%_ltrafiltration%', text: 'Ultrafiltration'},
	{ key: '%V96_peptide_affinity%', text: 'V96 peptide affinity'},
	{ key: '%Vn96_(ME_kit)%', text: 'Vn96 (ME kit)'},
	{ key: '%Volume exclusion%', text: 'Volume exclusion'},
];

const options_search: IChoiceGroupOption[] = [
	{ key: '/search', text: 'Biofluids' },
	{ key: '/search_in_vitro', text: 'In-Vitro' },
	{ key: '/search_in_vivo', text: 'In-Vivo' },
  ];

const options_enzymaticdigestion = [
	{ key: '', text: 'Select an option'},
	{ key: '%Benzonase%', text: 'Benzonase'},
	{ key: '%Dnase%', text: 'Dnase'},
	{ key: '%Heparinase%', text: 'Heparinase'},
	{ key: '%MNase%', text: 'MNase'},
	{ key: '%Proteinase K%', text: 'Proteinase K'},
	{ key: '%Rnase%', text: 'Rnase'},
	{ key: '%Not%', text: 'Not Treated/Not reported'},
];

const options_EVsubtypesstudied = [
	{ key: '', text: 'Select an option'},
	{ key: '%Apoptotic_Bodies%', text: 'Apoptotic Bodies'},
	{ key: '%Circulating_Tumor-derived_Extracellular_Vesicles%', text: 'Circulating Tumor-derived Extracellular Vesicles'},
	{ key: '%Exosomes%', text: 'Exosomes'},
	{ key: '%Extracellular_Vesicles%', text: 'Extracellular Vesicles'},
	{ key: '%Large_Extracellular_Vesicles%', text: 'Large Extracellular Vesicles'},
	{ key: '%Medium_extracellular_Vesicles%', text: 'Medium extracellular Vesicles'},
	{ key: '%Microparticles%', text: 'Microparticles'},
	{ key: '%Microvesicles%', text: 'Microvesicles'},
	{ key: '%Nanoscale_Extracellular_Vesicles%', text: 'Nanoscale_Extracellular_Vesicles'},
	{ key: '%Prostasomes%', text: 'Prostasomes'},
	{ key: '%Small_Extracellular_Vesicles%', text: 'Small Extracellular Vesicles'},
	{ key: '%Unspecified%', text: 'Unspecified'},
];

const option_to_name = [
	{ key: '', text: 'Select an option'},
	{ key: 'Disease', text: 'diseases'},
	{ key: 'Biofluid', text: 'source'},
	{ key: 'Genes', text: 'genes'},
	{ key: 'Mutations', text: 'mutations'},
	{ key: 'Year of publications', text: 'yearofpublications'},
	{ key: 'EV isolation methods', text: 'evisolationmethods'},
	{ key: 'Enzymatic digestion', text: 'enzymaticdigestion'},
	{ key: 'Author', text: 'references'},
	{ key: 'Results', text: 'results'},
	{ key: 'Method of detection', text: 'methodofdetection'},
	{ key: 'EV Type', text: 'EVsubtypesstudied'},
];
  
  function App() {
	  const [selectedKey, setSelectedKey] = React.useState('/search');
	  const [diseases,setdiseases] = React.useState({ key: '', text: ''});
	  const [source,setsource] = React.useState({ key: '', text: ''});
	  //const [genes,setgenes] = React.useState({ key: '', text: ''});
	  //const [mutations,setmutations] = React.useState({ key: '', text: ''});
	  const [yearofpublications,setyearofpublications] = React.useState({ key: '', text: ''});
	  const [evisolationmethods,setevisolationmethods] = React.useState({ key: '', text: ''});
	  const [enzymaticdigestion,setenzymaticdigestion] = React.useState({ key: '', text: ''});
	  const [reference,setreference] = React.useState("");
	  const [results,setresults] = React.useState("");
	  const [genes,setgenes] = React.useState("");
	  const [mutations,setmutations] = React.useState("");
	  const [methodofdetection,setmethodofdetection] = React.useState("");
	  const [EVsubtypesstudied,setEVsubtypesstudied] = React.useState({ key: '', text: ''});
	  const [option, setOption] = React.useState(options_EVsubtypesstudied);
	  const [EVTrackID,setEVTrackID] = React.useState('');
	  const [PubMedID,setPubMedID] = React.useState('');
	  const [EVADDID,setEVADDID] = React.useState('');
	  const onChange = (ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void => {
		setSelectedKey(option.key);
		window.location.href = option.key
		// Perform other actions here, such as setting state or updating context
	  };
	return (
	<Stack style={{marginBottom:40}} verticalAlign='true' wrap = 'true' >



<Stack horizontalAlign="center" horizontal="true">
<ChoiceGroup
      label="Search Type"
      selectedKey={selectedKey}
      options={options_search}
      onChange={onChange}
      required={true}
	  styles={{
        flexContainer: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          // Add gap between radio buttons
          '> *:not(:last-child)': {
            marginRight: 10,
          },
        },
      }}

    />
</Stack>

<Stack horizontalAlign="center" horizontal="true" tokens={{childrenGap: 20}}>
	<Dropdown
		placeholder="Select an option"
		label={"Disease"}
		options={options_diseases}
		styles={dropdownStyles}
		onChange = {(e,option) => {setdiseases(option);}}
	/>
	<Dropdown
		placeholder="Select an option"
		label={"Biofluid"}
		options={options_source}
		styles={dropdownStyles}
		onChange = {(e,option) => {setsource(option);}}
	/>
</Stack>
<Stack horizontalAlign="center" horizontal="true" tokens={{childrenGap: 20}}>
	<Dropdown
			placeholder="Select an option"
			label={"Enzyme Digestion"}
			options={options_enzymaticdigestion}
			styles={dropdownStyles}
			onChange = {(e,option) => {setenzymaticdigestion(option);}}
		/>
		<Dropdown
		placeholder="Select an option"
		label={"Year of publications"}
		options={option_yearofpublications}
		styles={dropdownStyles}
		onChange = {(e,option) => {setyearofpublications(option);}}
	/>
		
</Stack>
<Stack horizontalAlign="center" horizontal="true" tokens={{childrenGap: 20}} style={{marginRight:220}}>
<Dropdown
		placeholder="Select an option"
		label={"EV Type"}
		options={option}
		styles={{dropdown: { width: 400 }}}
		onChange = {(e,option) => {setEVsubtypesstudied(option);}}
		defaultSelectedKeys = {0}
	/>
</Stack>

<Stack horizontalAlign="center" horizontal="true" tokens={{childrenGap: 20}}>
<Dropdown
		placeholder="Select an option"
		label={"EV isolation methods"}
		options={options_evisolationmethods}
		styles={{dropdown: { width: 620 }}}
		onChange = {(e,option) => {setevisolationmethods(option);}}
	/>

</Stack>

<Stack horizontalAlign="center" horizontal="true" tokens={{childrenGap: 20}}>
	{/* <Dropdown
		placeholder="Select an option"
		label={"Genes"}
		options={options_genes}
		styles={dropdownStyles}
		onChange = {(e,option) => {setgenes(option);}}
	 />
	 <Dropdown
		placeholder="Select an option"
		label={"Mutations"}
		options={options_mutations}
		styles={dropdownStyles}
		onChange = {(e,option) => {setmutations(option);}}
	/>
	*/}
	<TextField 
			label="Enter a gene name, i.e. KRAS"
			onChange={(e,txt) => {setgenes(txt);}}
			styles={{fieldGroup: { width: 300 }}}
	/>
	<TextField 
			label="Enter a mutation, i.e. G12V"
			onChange={(e,txt) => {setmutations(txt);}}
			styles={{fieldGroup: { width: 300 }}}
	/>
	
</Stack>

<Stack horizontalAlign="center" horizontal="true" tokens={{childrenGap: 20}}>
<TextField 
			label="Method of Detection"
			onChange={(e,txt) => {setmethodofdetection(txt);}}
			styles={{fieldGroup: { width: 300 }}}
		/>
	<TextField 
			label="Author"
			onChange={(e,txt) => {setreference(txt);}}
			styles={{fieldGroup: { width: 300 }}}
		/>


</Stack >

<Stack horizontalAlign="center" horizontal="true" tokens={{childrenGap: 20}}>
<TextField 
			label="EVTrack ID"
			onChange={(e,txt) => {setEVTrackID(txt);}}
			styles={{fieldGroup: { width: 300 }}}
		/>
	<TextField 
			label="PubMed ID"
			onChange={(e,txt) => {setPubMedID(txt);}}
			styles={{fieldGroup: { width: 300 }}}
		/>


</Stack >

<Stack horizontalAlign="center" horizontal="true" tokens={{childrenGap: 20}}>
<TextField 
			label="EVADD ID"
			onChange={(e,txt) => {setEVADDID(txt);}}
			styles={{fieldGroup: { width: 620 }}}
		/>


</Stack >

<Stack  horizontalAlign = "center" childrenGap = "100" horizontal>

	{/*<Stack style={{marginTop:30, marginLeft:71}} tokens={stackTokens} horizontal childrenGap = {20}>*/}
	<Stack style={{marginTop:30}} tokens={stackTokens} horizontal childrenGap = {20}>	
	<PrimaryButton 
		styles = {{}}
		text="Whole Database" 
		onClick={() =>{
			window.alert("This will show the whole dataset")
			//window.open("/ev_database")
			window.location.href = "/ev_database"
		}}
	/>
	<PrimaryButton 
		styles = {{}}
		text="Search" 
		onClick={() =>{
		let prefix = 'wpda_search_column_'
		let begin = '/ev_database/?'
		let result = begin
		if (source.key != ''){
			result = result.concat(prefix,option_to_name[2].text,"=",source.key,"&")
		}
		if (diseases.key != ''){
			result = result.concat(prefix,option_to_name[1].text,"=",diseases.key,"&")
		}
		if (genes != ''){
			result = result.concat(prefix,option_to_name[3].text,"=","%_",genes,"%","&")
		}
		if (mutations != ''){
			result = result.concat(prefix,option_to_name[4].text,"=","%_",mutations,"%","&")
		}
		if (yearofpublications.key != ''){
			result = result.concat(prefix,option_to_name[5].text,"=",yearofpublications.key,"&")
		}
		if (evisolationmethods.key != ''){
			result = result.concat(prefix,option_to_name[6].text,"=",evisolationmethods.key,"&")
		}
		if (enzymaticdigestion.key != ''){
			result = result.concat(prefix,option_to_name[7].text,"=",enzymaticdigestion.key,"&")
		}
		if (reference != ''){
			result = result.concat(prefix,option_to_name[8].text,"=","%",reference,"%_rl%&")
		}
		if (methodofdetection != ''){
			result = result.concat(prefix,option_to_name[10].text,"=","%",methodofdetection,"%&")
		}
		if (EVsubtypesstudied.key != ''){
			result = result.concat(prefix,option_to_name[11].text,"=",EVsubtypesstudied.key,"%&")
		}
		if (EVTrackID != ''){
			result = result.concat(prefix,'EVTrackID',"=","",EVTrackID,"&")
		}
		if (PubMedID != ''){
			result = result.concat(prefix,'PubMedID',"=","",PubMedID,"&")
		}
		if (EVADDID != ''){
			result = result.concat(prefix,'EVADDID',"=","",EVADDID,"&")
		}
		if (result == begin){
			window.alert("No search criteria. This will show the whole dataset")
			window.location.href = "/ev_database"
			//window.open("/ev_database")
		}else{
			//window.open(result)
			result = result.replace(/ /g,"_");
			result = result.replaceAll("-","_");
			result = result.replaceAll("‐","_");
			window.location.href = result
		}
		
		}}
		
		allowDisabledFocus 
		disabled={false} 
		checked={false} 
	/>

	</Stack >
	</Stack>
	</Stack>
  );
};

export default App;